import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const OfflineBanner = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const { language } = useContext(AuthContext);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline) return null;

  const message =
    language === 'el'
      ? 'Είστε εκτός σύνδεσης. Εμφανίζονται αποθηκευμένα δεδομένα.'
      : 'You are offline. Showing cached data.';

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: '#7c3aed',
        color: '#ffffff',
        textAlign: 'center',
        padding: '10px 16px',
        zIndex: 99999,
        fontSize: '14px',
        fontWeight: '500',
        letterSpacing: '0.01em',
      }}
    >
      {message}
    </div>
  );
};

export default OfflineBanner;
